import Home from './components'

export default {
  key: 'home',
  exact: true,
  path: '/',
  component: Home,
}
